import {
  GET_CONTENANTS,
  ADD_CONTENANT,
  UPDATE_CONTENANT,
  DELETE_CONTENANT
} from '../actions/action-types';

const initialState = {
  list: []
};

export default function contenantsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CONTENANTS:
      return { ...state, list: action.payload || [] };
    case ADD_CONTENANT:
      return { ...state, list: [action.payload, ...state.list] };
    case UPDATE_CONTENANT:
      return {
        ...state,
        list: state.list.map(c => c.id === action.payload.id ? { ...c, ...action.payload } : c)
      };
    case DELETE_CONTENANT:
      return { ...state, list: state.list.filter(c => c.id !== action.payload) };
    default:
      return state;
  }
}
